import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AppContext } from 'src/app/services/app-context.service';

@Component({
  selector: 'gar-ui-image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.scss'],
})
export class ImageGalleryComponent implements OnInit {
  @Input() hotelDetails: any;
  @Input() images: any[] = [];
  @Output() eventClick = new EventEmitter();
  /** Current image details on carousel */
  activeBackground: any;
  /** Index for current image */
  activeBackgroundIndex = 0;
  @Input()
  set setHotelDetails(details: any) {
    this.hotelDetails = details;

    if (this.hotelDetails.images) {
      this.images = this.hotelDetails.images;
      this.activeBackground =
        this.hotelDetails.images[this.activeBackgroundIndex];
    }
  }

  @Input()
  set roomImages(images: any) {
    this.images = images;

    if (images) {
      this.activeBackground = images[this.activeBackgroundIndex];
    }
  }

  constructor(public appContext: AppContext) {}

  /** Show previous image */
  prevImage() {
    this.activeBackgroundIndex--;
    if (this.activeBackgroundIndex < 0) {
      this.activeBackgroundIndex = this.images.length - 1;
    }
    this.activeBackground = this.images[this.activeBackgroundIndex];
  }

  /** Show next image */
  nextImage() {
    this.activeBackgroundIndex++;
    if (this.activeBackgroundIndex === this.images.length) {
      this.activeBackgroundIndex = 0;
    }

    this.activeBackground = this.images[this.activeBackgroundIndex];
  }

  eventCall(event: any) {
    this.eventClick.emit(event);
  }
  ngOnChanges() {
    if (this.images) {
      const img = new Image();
      img.src = this.images[0].url;
      img.onerror = () => {
        this.setDefaultImage();
      };
    }
  }
  ngOnInit() {}
  setDefaultImage() {
    // Replace the heroImage with the URL of your default image
    this.activeBackground.url = './assets/images/RoomImageNotFound.jpg';
  }
}
